import React, { createContext, useContext, useState, useEffect, ReactNode } from "react";
import { AccountInfo, IPublicClientApplication } from "@azure/msal-browser";
import { useMsal } from "@azure/msal-react";

interface AuthContextProps {
    user: AccountInfo | null;
    setUser: React.Dispatch<React.SetStateAction<AccountInfo | null>>;
    instance: IPublicClientApplication;
    accounts: AccountInfo[];
}

const AuthContext = createContext<AuthContextProps | undefined>(undefined);

interface AuthProviderProps {
    children: ReactNode;
}

export const AuthProvider: React.FC<AuthProviderProps> = ({ children }) => {
    const { instance, accounts } = useMsal();
    const [user, setUser] = useState<AccountInfo | null>(null);

    useEffect(() => {
        if (accounts.length > 0) {
            setUser(accounts[0]);
        }
    }, [accounts]);

    return (
        <AuthContext.Provider value={{ user, setUser, instance, accounts }}>
            {children}
        </AuthContext.Provider>
    );
};

export const useAuth = (): AuthContextProps => {
    const context = useContext(AuthContext);
    if (!context) {
        throw new Error("useAuth must be used within an AuthProvider");
    }
    return context;
};